import { RepositoryFactory } from '@/api/RepositoryFactory'
import { SET_LOADING, UPDATE_CLIENT } from '@/store/actions/clients'
import { initialPagination } from '@/datas/Pagination'
import { preparePagination } from '@/helpers/store'

const API = RepositoryFactory.get('tableOfPayments')
const token = localStorage.getItem('auth-token')

export default {
  namespaced: true,
  state: {
    paymentsData: [],
    pagination: initialPagination,
    loading: true,
  },
  getters: {
    getPaymentsData: state => state.paymentsData,
    getLoading: state => state.loading,
    getPaymentsPagination: state => state.pagination,
  },
  actions: {
    fetchMassPaymentsFromBank(
      { commit, rootGetters },
      settings = {
        payment_ids: [],
        first_payment_number: 0,
        export_all: 0,
      },
    ) {
      return API.getMassExportPayments({
        ...settings,
        'bearer-token': rootGetters['auth/getToken'],
      })
    },
    fetchPaymentsData({ commit }, settings) {
      commit('setLoading', true)

      API.getPaymentsData(settings)
        .then(({ data, headers }) => {
          commit('setPagination', preparePagination(headers))
          commit('setPaymentsData', data)
        })
        .catch(error => console.log(error))
        .finally(() => commit('setLoading', false))
    },
    createPayment({ commit }, data) {
      return API.postPayment(data)
    },
    createMassPayments({ commit }, data) {
      return API.postMassPayments(data)
    },
  },
  mutations: {
    setPaymentsData(state, payload) {
      state.paymentsData = payload
    },
    setPagination(state, payload) {
      state.pagination = payload
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    updatePaymentsData(state, item) {
      if (item.length > 1) {
        item.map(x => {
          if (x.response_id) {
            state.paymentsData.map(y => {
              if (x.payment_id === y.id) {
                y.payment_date = x.payment_date
                y.payment_status = Number(x.payment_status)
                y.updated_at = x.updated_at
              }
            })
          }
        })
      }
    },
  },
}
